import { useEffect, useMemo, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { TrashIcon, PlusIcon } from "@phosphor-icons/react";

const CATS = ["Άνεση", "Ασφάλεια", "Multimedia", "Εξωτερικό", "Γενικά"];

export default function EquipmentManager() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("Γενικά");

  const load = useCallback(async () => {
    const r = await api.get("/equipment");
    setItems(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e?.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/equipment", { name, category });
      setName("");
      toast.success("Προστέθηκε");
      load();
    } catch {
      toast.error("Αποτυχία");
    }
  };

  const del = async (id, is_default) => {
    if (is_default) return;
    if (!window.confirm("Διαγραφή;")) return;
    try {
      await api.delete(`/equipment/${id}`);
      toast.success("Διαγράφηκε");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Αποτυχία");
    }
  };

  const grouped = useMemo(() => items.reduce((acc, it) => {
    const c = it.category || "Γενικά";
    acc[c] = acc[c] || [];
    acc[c].push(it);
    return acc;
  }, {}), [items]);

  const visibleCats = useMemo(() => CATS.filter((c) => grouped[c]), [grouped]);

  return (
    <div className="space-y-6 max-w-5xl" data-testid="equipment-page">
      <div className="border border-black/10 bg-[#F9FAFB] p-6">
        <div className="text-[10px] uppercase tracking-[0.18em] text-[#4B5563] mb-2">
          Διαχείριση εξοπλισμού
        </div>
        <p className="text-sm text-[#4B5563] mb-4">
          Προσθέστε ή διαγράψτε στοιχεία εξοπλισμού. Τα προσαρμοσμένα στοιχεία αποθηκεύονται και είναι διαθέσιμα για όλα τα μελλοντικά αυτοκίνητα.
        </p>
        <form onSubmit={add} className="flex flex-col md:flex-row gap-2">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Όνομα εξοπλισμού"
            data-testid="manage-eq-name"
            className="flex-1 px-3 py-2 border border-black/20 bg-white outline-none focus:border-[#0055FF] text-sm"
          />
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            data-testid="manage-eq-category"
            className="px-3 py-2 border border-black/20 bg-white outline-none text-sm"
          >
            {CATS.map((c) => <option key={c}>{c}</option>)}
          </select>
          <button type="submit" className="btn-primary text-sm flex items-center gap-1.5" data-testid="manage-eq-add">
            <PlusIcon size={14} /> Προσθήκη
          </button>
        </form>
      </div>

      {visibleCats.map((cat) => (
        <div key={cat} className="border border-black/10 bg-white">
          <div className="px-6 py-3 bg-[#F9FAFB] border-b border-black/10 flex items-center justify-between">
            <h3 className="heading font-bold text-base">{cat}</h3>
            <span className="text-[10px] font-mono text-[#4B5563]">{grouped[cat].length} στοιχεία</span>
          </div>
          <div className="divide-y divide-black/5">
            {grouped[cat].map((it) => (
              <div key={it.id} className="px-6 py-2.5 flex items-center justify-between hover:bg-[#F9FAFB]" data-testid={`eq-item-${it.id}`}>
                <div className="flex items-center gap-3">
                  <span className="text-sm">{it.name}</span>
                  {!it.is_default && (
                    <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 bg-[#0055FF] text-white font-mono">custom</span>
                  )}
                </div>
                {!it.is_default && (
                  <button
                    onClick={() => del(it.id, it.is_default)}
                    className="p-1.5 hover:bg-[#E60000] hover:text-white transition-colors"
                    data-testid={`delete-eq-${it.id}`}
                  >
                    <TrashIcon size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
